module.exports = __webpack_public_path__ + "img/diseño.35899c85.png";